import clsx from 'clsx'
import classes from '../Card.module.scss'
import { AudioIcon } from './AudioIcon'
import { AudioComponentControl } from '@educaplay/core/components/AudioComponentControl'

export function CardAudio({ cardData, isPressed, autoplay }) {
    return (
      <div className={clsx(classes.card__content)}>
        <AudioComponentControl
          source={cardData.source} 
          insideButton
          className={classes.audioComponent}
          autoplay={isPressed && autoplay}
         />
        <AudioIcon className={classes.card__icon} />
      </div>
    )
}